import { call, put, takeEvery } from 'redux-saga/effects';
import {
    FETCH_PARTNERS_REQUEST,
    FETCH_PARTNERS_SUCCESS,
    FETCH_PARTNERS_FAILURE,
    FETCH_PARTNER_BY_ID_REQUEST,
    FETCH_PARTNER_BY_ID_SUCCESS,
    FETCH_PARTNER_BY_ID_FAILURE,
    CREATE_PARTNER_REQUEST,
    CREATE_PARTNER_SUCCESS,
    CREATE_PARTNER_FAILURE,
    UPDATE_PARTNER_REQUEST,
    UPDATE_PARTNER_SUCCESS,
    UPDATE_PARTNER_FAILURE,
    DELETE_PARTNER_REQUEST,
    DELETE_PARTNER_SUCCESS,
    DELETE_PARTNER_FAILURE,
    CREATE_PARTNER_ACCOUNT_REQUEST,
    CREATE_PARTNER_ACCOUNT_SUCCESS,
    CREATE_PARTNER_ACCOUNT_FAILURE,
} from '../actions/partnerActions';
import {
    getPartners,
    getPartnerById,
    createPartner,
    updatePartner,
    deletePartner,
    createPartnerAccount,
} from '../../services/api';
import { handleApiError } from '../../utils/errorHandler';

function* fetchPartnersSaga(action) {
    try {
        const params = action.payload || {};
        const data = yield call(getPartners, params);
        yield put({ type: FETCH_PARTNERS_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement des partenaires');
        yield put({ type: FETCH_PARTNERS_FAILURE, payload: errorMessage });
    }
}

function* fetchPartnerByIdSaga(action) {
    try {
        const data = yield call(getPartnerById, action.payload);
        yield put({ type: FETCH_PARTNER_BY_ID_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors du chargement du partenaire');
        yield put({ type: FETCH_PARTNER_BY_ID_FAILURE, payload: errorMessage });
    }
}

function* createPartnerSaga(action) {
    try {
        const data = yield call(createPartner, action.payload);
        yield put({ type: CREATE_PARTNER_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création du partenaire');
        yield put({ type: CREATE_PARTNER_FAILURE, payload: errorMessage });
    }
}

function* updatePartnerSaga(action) {
    try {
        const { partnerId, partnerData } = action.payload;
        const data = yield call(updatePartner, partnerId, partnerData);
        yield put({ type: UPDATE_PARTNER_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la mise à jour du partenaire');
        yield put({ type: UPDATE_PARTNER_FAILURE, payload: errorMessage });
    }
}

function* deletePartnerSaga(action) {
    try {
        yield call(deletePartner, action.payload);
        yield put({ type: DELETE_PARTNER_SUCCESS, payload: action.payload });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la suppression du partenaire');
        yield put({ type: DELETE_PARTNER_FAILURE, payload: errorMessage });
    }
}

function* createPartnerAccountSaga(action) {
    try {
        const data = yield call(createPartnerAccount, action.payload);
        yield put({ type: CREATE_PARTNER_ACCOUNT_SUCCESS, payload: data });
    } catch (error) {
        const errorMessage = handleApiError(error, 'Erreur lors de la création du compte partenaire');
        yield put({ type: CREATE_PARTNER_ACCOUNT_FAILURE, payload: errorMessage });
    }
}

export function* watchPartnerRequests() {
    yield takeEvery(FETCH_PARTNERS_REQUEST, fetchPartnersSaga);
    yield takeEvery(FETCH_PARTNER_BY_ID_REQUEST, fetchPartnerByIdSaga);
    yield takeEvery(CREATE_PARTNER_REQUEST, createPartnerSaga);
    yield takeEvery(UPDATE_PARTNER_REQUEST, updatePartnerSaga);
    yield takeEvery(DELETE_PARTNER_REQUEST, deletePartnerSaga);
    yield takeEvery(CREATE_PARTNER_ACCOUNT_REQUEST, createPartnerAccountSaga);
}

